import { ActionSubject, runAction } from "../action";
import { LanguageCode } from "shared";

export const languageAction = {
	set: new ActionSubject<LanguageCode>()
};

export const setLanguage = (code: LanguageCode) => runAction(languageAction.set, () => code);
